<template>
    <div>
        <left-column :style="{backgroundImage:bgImg}" ></left-column>
        <right-column>
            <h2 style="font-size: 2rem">{{$t('step_success.heading')}}</h2>
            <p style="font-size: 1.4rem">{{$t('step_success.subheading')}}
            <br />
            </p>
            <div v-html="$t('step_success.text')">
            </div>
        </right-column>
    </div>
</template>
<script>
import LeftColumn from "../LeftColumn";
import RightColumn from "../RightColumn";
const accessoriesList = window.wgCalc.accessoriesList || [];
export default {
    name:'StepSuccess',
    components: {RightColumn, LeftColumn},
    data(){
        return {

        }
    },
    computed:{
        bgImg(){
            if(this.$storage.state.summary.panels.type){
                const accs = accessoriesList.filter( item => this.$storage.state.summary.products.indexOf(item.key)!==-1)
                return `url(${require('@/assets/bg/house/house_'+this.$storage.state.summary.roof.type.toString()+'deg_'+this.$storage.state.summary.panels.type.toString()+(accs.length && window.wgCalc.showAddonImages ? '_'+accs.map(y =>{ return y.key }).join("_") : '')+'.jpg')})`;
            }
            return `url(${require('@/assets/bg/house/house_0deg_essential.jpg')})`;
        },
    }
}
</script>
